import * as React from 'react';

const AlignRightChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="align-right-chunky_svg__eds-icon--align-right-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="align-right-chunky_svg__eds-icon--align-right-chunky_bottom"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 17h16v2H4v-2z"
        />
        <path
            className="align-right-chunky_svg__eds-icon--align-right-chunky_middle"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 11h8v2h-8z"
        />
        <path
            className="align-right-chunky_svg__eds-icon--align-right-chunky_top"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 5h16v2H4z"
        />
    </svg>
);

AlignRightChunkySvg.displayName = 'AlignRightChunkySvg';
export default AlignRightChunkySvg;
